import { create } from "zustand";

interface SupportStore {
  open: boolean;
  /** Viewport-top of the element that opened the panel, so it aligns with its
   *  trigger. Null → the panel centers itself next to the sidebar. */
  anchorTop: number | null;
  openSupport: (anchorTop?: number) => void;
  closeSupport: () => void;
}

export const useSupportStore = create<SupportStore>((set) => ({
  open: false,
  anchorTop: null,
  openSupport: (anchorTop) => set({ open: true, anchorTop: anchorTop ?? null }),
  closeSupport: () => set({ open: false }),
}));
